import CartCommon from '@/app-core/mixins/cart/cartCommon'

export default {
  name      : 'PaymentMinimumOrderWarning',
  components: {},
  directives: {},
  mixins    : [CartCommon],
  props     : {
    dense: {
      type   : Boolean,
      default: false
    },

    sortText: {
      type   : Boolean,
      default: false
    },

    text: {
      type   : Boolean,
      default: false
    },

    color: {
      type   : String,
      default: 'info'
    },

    coloredBorder: {
      type   : Boolean,
      default: false
    },

    border: {
      type   : String,
      default: 'left'
    },

    type: {
      type   : String,
      default: 'info'
    }
  },
  enums    : {},
  dataModel: null,
  data() {
    return {}
  },
  computed: {},
  watch   : {},
  beforeCreate() {
  },
  created() {
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {}
}
